<template lang="pug">
  v-fade-transition
    v-progress-linear(
      v-if="isActive"
      fixed
      top
      indeterminate)
</template>

<script>
import { toRefs } from '@vue/composition-api'
import { state } from '..'

import { VFadeTransition, VProgressLinear } from 'vuetify/lib'

export default {
  components: {
    VFadeTransition, VProgressLinear
  },

  setup () {
    return {
      ...toRefs(state)
    }
  }
}
</script>
